import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { X } from 'lucide-react'
import TermsContent from './TermsContent'
import { useAuth } from '@/contexts/AuthContext'

const REGIONAL_HOMES: Record<string, string> = {
  US: 'https://nimonikapp.com/',
  CN: 'https://www.nimonikapp.com.cn/',
  AU: 'https://www.au.nimonikapp.com/',
  FR: 'https://nimonikapp.eu/',
}
const DEFAULT_HOME = 'https://nimonikapp.com/'

export default function FooterBar() {
  const { t, i18n } = useTranslation()
  const { region } = useAuth()
  const homeUrl = (region && REGIONAL_HOMES[region]) || DEFAULT_HOME
  const [showTermsModal, setShowTermsModal] = useState(false)

  return (
    <>
      <div className="pb-1.5 px-4 text-center text-xs text-gray-400 flex items-center justify-center gap-1.5">
        <a
          href={homeUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-gray-600 transition-colors"
        >
          {t('footer.home')}
        </a>
        <span>·</span>
        <a
          href="https://nimonik.com/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-gray-600 transition-colors"
        >
          {t('footer.privacy')}
        </a>
        <span>·</span>
        <button
          onClick={() => setShowTermsModal(true)}
          className="hover:text-gray-600 transition-colors"
        >
          {t('footer.termsOfUse')}
        </button>
        <span>·</span>
        <a
          href={`${homeUrl}support`}
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-gray-600 transition-colors"
        >
          {t('footer.support')}
        </a>
      </div>

      {showTermsModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
          onClick={() => setShowTermsModal(false)}
        >
          <div
            className="bg-white rounded-xl shadow-lg max-w-2xl w-full mx-4 max-h-[80vh] flex flex-col"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between p-4 border-b">
              <h2 className="text-lg font-semibold text-gray-800">{t('footer.termsOfUse')}</h2>
              <button
                onClick={() => setShowTermsModal(false)}
                className="p-1 rounded-lg hover:bg-gray-100 transition-colors"
              >
                <X className="w-5 h-5 text-gray-500" />
              </button>
            </div>
            <div className="p-6 overflow-y-auto text-sm text-brand-blue-dark leading-relaxed">
              <TermsContent language={i18n.language} />
            </div>
          </div>
        </div>
      )}
    </>
  )
}
